<template>
  <div class="tableWithPerPageSelection"
       v-if="dates.dateDebut && dates.dateFin">
    <a ref="lienDownload"></a>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <form @submit.prevent="recherche()" class="column is-narrow">
            <b-input :placeholder="$t('general.button.search')"
                     type="search"
                     icon="magnify"
                     v-model="criteresRecherche.auto">
            </b-input>
          </form>
          <div class="column is-narrow">
            <date-picker :dates="dates" @recherche="recherche" time="years" :amount=1 />
          </div>
          <div class="column is-narrow">
            <button class="button" @click='showFiltre = !showFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('general.button.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiser()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="columns level-right">
        <div class="column is-narrow">
          <exportExcelButton
          :perm="permTiers.exporter"
          :query="exportExcelQuery"
          :secondaryExports="secondaryActions"/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <div class="level mgt-20px">
        <div class="level-left">
        </div>
      <div class="level-right">
        <div class="shadow height-35 has-background-white width-340 columns
            is-marginless is-vcentered">
            <span class="column">
                {{$t('detailClient.budget.budgetTotalHt')}} :
            </span>
            <span class="has-text-weight-bold column is-narrow">
                {{montantTotalHt | formatDevise}}
            </span>
        </div>
      </div>
    </div>
    <v-server-table
      url=""
      :columns="columns"
      :options="options"
      :ref="referenceTable"
      @loaded="finLoading"
      @loading="debutLoading"
      v-if="startArrayRendering && mountedLoadingEnd">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)" />
      </template>
      <div slot="groupe" slot-scope="props">
        <div v-if="props.row.groupe">
            <router-link-blank :to="{ name: 'c.bodac.clients/contacts-budget',
                params: {id: props.row.groupe.id}}"
                :message="props.row.groupe.nomCommercial">
            </router-link-blank>
         </div>
      </div>
      <div slot="enseigne" slot-scope="props">
          <div v-if="props.row.enseigne">
            <router-link-blank :to="{ name: 'c.bodac.clients/contacts-budget',
                params: {id: props.row.enseigne.id}}"
                :message="props.row.enseigne.nomCommercial">
            </router-link-blank>
          </div>
      </div>
      <div slot="pointDeVente" slot-scope="props">
        <div v-if="props.row.pointDeVente">
            <router-link-blank :to="{ name: 'c.bodac.clients/contacts-budget',
                params: {id: props.row.pointDeVente.id}}"
                :message="props.row.pointDeVente.nomCommercial">
            </router-link-blank>
        </div>
      </div>
      <div slot="dateDebut" slot-scope="props">
        <span>
          {{ props.row.dateDebut | formatDate }}
        </span>
      </div>
      <div slot="dateFin" slot-scope="props">
        <span>
          {{ props.row.dateFin| formatDate }}
        </span>
      </div>
      <div slot="montantHt" slot-scope="props" class="has-text-right">
        {{ props.row.montantHt | formatDevise }}
      </div>
      <div slot="referencesProduits" slot-scope="props">
          <div v-if="props.row.typeProduit">
              <router-link-blank :to="{ name: getRouteProduit(props.row),
                params: {id: props.row.IdsProduits}}"
                :message="props.row.referencesProduits">
              </router-link-blank>
          </div>
      </div>
      <div slot="libelleEcheance" slot-scope="props">
          <div>
              <router-link-blank :to="{ name: 'c.bodac.commandes',
                params: {id: props.row.commandeId}}"
                :message="props.row.libelleEcheance">
              </router-link-blank>
          </div>
       </div>
    </v-server-table>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
     <div class="componentBrief" v-show="showFiltre">
        <filtre-budget ref="filtreBudget"
                                           @toggleFiltre="showFiltre = !showFiltre"
                                           @recherche="makeRechercheFilter" />
      </div>
    </transition>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import datePicker from '@/components/general/datePicker';
import messageErreur from '@/services/general/messageErreur';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { TIERS } from '@/configuration/permissionsBodacConf';
import { TYPOLOGIE_ENSEIGNE, TYPOLOGIE_GROUPE, TYPOLOGIE_POINT_DE_VENTE } from '@/configuration/tiers/tiersConf';
import { COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import { CATEGORIE_PRODUIT } from '@/configuration/catalogue/produitConf';
import moment from 'moment';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_ECHEANCES } from '@/configuration/general/referenceTableConf';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import filtreBudget from './filtreBudget';

const Societe = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');
const Permissions = createNamespacedHelpers('permissions');
const EcheanceFacturation = createNamespacedHelpers('echeanceFacturation');

export default {
  name: 'ClientBudget',
  props: {
    tiersInformation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loadingComponent: null,
      showFiltre: false,
      permTiers: TIERS,
      dates: {
        dateDebut: null,
        dateFin: null,
      },
      referenceTable: REFERENCE_TABLE_ECHEANCES,
      mountedLoadingEnd: false,
      startArrayRendering: false,
      resultPerPage: RESULTS_PER_PAGE,
    };
  },
  components: {
    routerLinkBlank,
    datePicker,
    filtreBudget,
    TableItemsInView,
    parametrageTable,
    exportExcelButton,
  },
  computed: {
    ...EcheanceFacturation.mapGetters({
      criteresRecherche: 'criteresRecherche',
      echeancesFacture: 'items',
      totalCount: 'totalCount',
      montantTotalHt: 'montantTotalHt',
      lastPayload: 'lastPayload',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          groupe: this.$i18n.t('detailClient.budget.tab.groupe'),
          enseigne: this.$i18n.t('detailClient.budget.tab.enseigne'),
          pointDeVente: this.$i18n.t('detailClient.budget.tab.pointDeVente'),
          referencesProduits: this.$i18n.t('detailClient.budget.tab.referencesFace'),
          libelleEcheance: this.$i18n.t('detailClient.budget.tab.lignesCommandeRegroupementLibelle'),
          lignesCommandeLibelle: this.$i18n.t('detailClient.budget.tab.lignesCommandeLibelle'),
          dateDebut: this.$i18n.t('detailClient.budget.tab.dateDebut'),
          dateFin: this.$i18n.t('detailClient.budget.tab.dateFin'),
          montantHt: this.$i18n.t('detailClient.budget.tab.montantHt'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.criteresRecherche);
          data.query.tiersId = [this.$route.params.id];
          data.query.dates = cloneDeep(this.dates);
          data.query.sens = 'vente';
          data.query.societeId = this.societeActiveId;
          return this.loadEcheancier(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.echeancesFacture,
            count: this.totalCount,
          };
        }),
        sortable: [],
      };
    },
    columns() {
      let cols = [];
      switch (this.tiersInformation.typologie) {
        case TYPOLOGIE_GROUPE:
          cols.push('enseigne', 'pointDeVente');
          break;
        case TYPOLOGIE_ENSEIGNE:
          cols.push('groupe', 'pointDeVente');
          break;
        case TYPOLOGIE_POINT_DE_VENTE:
          cols.push('groupe', 'enseigne');
          break;
        default: break;
      }
      cols = cols.concat(['referencesProduits', 'libelleEcheance', 'lignesCommandeLibelle', 'dateDebut', 'dateFin', 'montantHt']);
      return cols;
    },
    nombreCritere() {
      const banCritere = ['auto', 'tiersId', 'sens', 'societeId'];
      const nbCritere = calculNombreCritere(this.criteresRecherche, banCritere);
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    filtrerParUtilisateur() {
      return this.parametresInterne(
        PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key,
      );
    },
    exportExcelQuery() {
      return {
        typeDonnee: 'echeancefacturation',
        typeExport: null,
        filtres: cloneDeep(this.lastPayload),
        parametresAdditionnels: {
          tiersId: this.tiersInformation.id,
        },
      };
    },
    secondaryActions() {
      return [
        {
          libelle: this.$t('detailClient.budget.actions.exportColonne'),
          query: {
            typeDonnee: 'echeancefacturation',
            typeExport: 'AAParColonnes',
            filtres: cloneDeep(this.lastPayload),
            parametresAdditionnels: {
              tiersId: this.tiersInformation.id,
            },
          },
        },
        {
          libelle: this.$t('detailClient.budget.actions.exportTousClient'),
          query: {
            typeDonnee: 'echeancefacturation',
            typeExport: 'AAParColonnes',
            filtres: cloneDeep(this.lastPayload),
            parametresAdditionnels: {
              tiersId: null,
            },
          },
        },
      ];
    },
  },
  methods: {
    ...EcheanceFacturation.mapActions({
      loadEcheancier: 'loadEcheances',
    }),
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    updateDatesForPeriode() {
      const actualMonth = moment().format('M');
      if (this.tiersInformation.moisDebutPeriodeBudgetaire) {
        const dateDebut = moment().month(this.tiersInformation.moisDebutPeriodeBudgetaire - 1).startOf('month');
        if (actualMonth < this.tiersInformation.moisDebutPeriodeBudgetaire) dateDebut.add(-1, 'year');
        this.dates.dateDebut = dateDebut.toDate();
      } else {
        this.dates.dateDebut = moment().startOf('year').utc().toDate();
      }
      if (this.tiersInformation.moisFinPeriodeBudgetaire) {
        const dateFin = moment().month(this.tiersInformation.moisFinPeriodeBudgetaire - 1).endOf('month');
        if (actualMonth > this.tiersInformation.moisFinPeriodeBudgetaire) dateFin.add(1, 'year');
        this.dates.dateFin = dateFin.toDate();
      } else {
        this.dates.dateFin = moment().endOf('year').utc().toDate();
      }
    },
    makeRechercheFilter() {
      this.showFiltre = !this.showFiltre;
      this.recherche();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    getRouteProduit(echeance) {
      return CATEGORIE_PRODUIT.find((categorie) => {
        return categorie.code === echeance.typeProduit;
      }).routeDetail;
    },
    async reinitialiser() {
      await this.$refs.filtreBudget.initializeFiltre();
      this.$refs.filtreBudget.viderCritere();
      this.$refs.filtreBudget.appliquerCritere();
      this.showFiltre = false;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key]);
      if (this.filtrerParUtilisateur && this.user.profil === COMMERCIAL) {
        this.criteresRecherche.commercialId = [this.user.id];
      }
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.tiersInformation.nomCommercial }));
      this.updateDatesForPeriode();
      this.mountedLoadingEnd = true;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>
